<template>
    <div class="under-header p-10" id="tabbed-section" :style="backgroundImageStyle">
        <div class="spinning-background-2 index-0"></div>
        <div class="mobile-background">
            <h1 class="font-medium layoutHeader blur">{{ page?.altTitle || page?.title || 'Untitled Page' }}</h1>
            <Splitter class="featuredSplitter">
                <SplitterPanel class="isotopesPanel" :size="55" :size-medium="100">
                    <div class="pt-4 pb-8 p-0 pr-8 relative">
                        <div v-if="page?.content" class="page-content large" v-html="processedContent(page.content)"></div>
                        <div v-if="page?.wistiaEmbed && isDirectVideoUrl(page.wistiaEmbed)" class="wistia-embed">
                            <OfflineVideo :src="resolveVideoSrc(page.wistiaEmbed)" />
                        </div>
                        <div v-else-if="page?.wistiaEmbed" class="wistia-embed">
                            <iframe :src="getWistiaEmbedUrl(page.wistiaEmbed)" webkit-playsinline="true" playsinline frameborder="0"></iframe>
                        </div>
                        <div v-if="page?.contentImage" class="wistia-embed rounded large">
                            <img :src="resolveImageUrl(page.contentImage)" :alt="`${page?.title || 'Content'} image`">
                        </div>
                    </div>
                </SplitterPanel>
                <SplitterPanel class="isotopesPanel" :size="45" :size-medium="100">
                    <div class="p-6  pr-0">
                        <div v-if="page?.secondContent" class="page-content rightSide" v-html="processedContent(page.secondContent)"></div>
                    </div>
                </SplitterPanel>
            </Splitter>
        </div>
    </div>
</template>
<script setup>
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import OfflineVideo from '../components/OfflineVideo.vue';
import { computed } from 'vue';
import { processContent } from '../utils/markdown.js';
import { useCommonStyles } from '../composables/useCommonStyles.js';
import { useMediaHelpers } from '../composables/useMediaHelpers.js';

const props = defineProps({
  page: Object,
  settings: Object
});

const { isDirectVideoUrl, resolveVideoSrc, resolveImageUrl, getWistiaEmbedUrl } = useMediaHelpers();

// Use common styles composable
const { backgroundImageStyle } = useCommonStyles(props);

// Process second content area with markdown
const processedContent = (content) => {
  return content ? processContent(content) : '';
};

</script>
